import * as React from 'react';

import GifPicker from './gif-picker';

import css from './dialog.css';


export default function EmojiDialog({
  ...props
}: {
  onClose: () => unknown;
  onSelect: (arg1: unknown) => void;
}) {
  return (
    <div className={css.dialog}>
      <GifPicker {...props} />
    </div>
  );
}
